import { useCallback, useRef } from "react";
import { TOOL_PANELS } from "../../components/DLabGrid/dLabGridConstant";

const useColumnDragSave = (onSave) => {
  const previousColumnSignatureRef = useRef("");
  const onSaveRef = useRef(onSave);
  onSaveRef.current = onSave;

  const onGridDragStopped = useCallback((event) => {
    const columnState = event?.columnApi?.getColumnState?.();
    if (!Array.isArray(columnState) || columnState.length === 0) { return; }

    const signature = columnState
      .filter((column) => column?.colId !== "ag-Grid-AutoColumn")
      .map((column) => `${column?.colId}:${column?.hide ? 1 : 0}`)
      .join("|");

    if (!signature || signature === previousColumnSignatureRef.current) { return; }
    previousColumnSignatureRef.current = signature;

    onSaveRef.current({
      currentState: columnState,
      pannel: TOOL_PANELS?.columns,
      type: "update",
      updateRedux: true
    });
  }, []);

  return { onGridDragStopped };
};

export default useColumnDragSave;
